import { createTheme } from "@mui/material";

// ATENÇÃO: MANTER CORES ATUALIZADAS COM AS VARIAVEIS DO INDEX.CSS

// paleta padrao não alterar
export const paletaPadrao = {
  laranja: "#BC6C25",
  laranjaClaro: "#DDA15E",
  verde: "#5C7F54",
  verdeEscuro: "#162419",
  pastel: "#FAFBFA",
};

export const theme = createTheme({
  typography: {
    allVariants: {
      color: "#575757ff",
      fontFamily: 'Work Sans'
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: paletaPadrao.verde,
    },
    secondary: {
      main: paletaPadrao.laranjaClaro,
      contrastText: paletaPadrao.pastel,
    },
    success: {
      main: paletaPadrao.verde,
    },
    warning: {
      main: "#fff47f",
    },
    error: {
      main: "#d47571",
    },
    info: {
      main: "#5A87B0",
    },
    common: {
      black: "#000",
      white: "#fff",
    },
    background: {
      default: paletaPadrao.pastel,
      paper: paletaPadrao.pastel,
    },
    text: {
      primary: "#575757",
      disabled: "#919191",
    },
  },
});

export const customColors = {
  // bgTroca: "#FF9F9F",
  bgTroca: theme.palette.error.main,
  roxoDasNotas: "#8d00d1",
  confereridoParcialBg: "#fffbd1",
  confereridoBg: "#8DAD85",
  cinzaClaro: theme.palette.grey["300"],
  verdeClaroClaro: "#4bd24b",
};
